import React from "react";
import VideoSection from "../components/home/VideoSection";
import AboutWithGallerySection from "../components/home/AboutWithGallerySection";
import VideoContentSection from "../components/home/VideoContentSection";
import AboutSection from "../components/home/AboutSection";

const Home = () => {
  return (
    <>
      <VideoSection />
      <AboutWithGallerySection />
      {/* <AboutSection /> */}
      <VideoContentSection />
    </>
  );
};

export default Home;